import { RouteConfig } from "vue-router";

export const ShopInventoryRoutes: Array<RouteConfig> = [{
					path: '',
					redirect: 'inventory/products'
				},{
                path: 'inventory',
                component: () => import(/* webpackChunkName: "shop-inventory" */ './views/ShopInventoryDashboard.vue'),
                children: [
                        {
                                path: '',
                                redirect: 'products'
                        }, {
                                path: 'products',
                                name: 'shop-inventory',
                                component: () => import('./views/ShopInventoryDashboardProducts.vue'),
                                children: [
                                  {
                                    path: 'new',
                                    name: 'shop-newProduct',
                                    component: () => import('./views/ShopInventoryCreateNewProduct.vue')
                                  },
                                  {
                                    path: ':product',
                                    name: 'shop-updateProduct',
                                    component: () => import('./views/ShopInventoryCreateNewProduct.vue')
                                  }
                                ]
                        }, {
                                path: 'categories',
                                name: 'shop-categories',
                                component: () => import('./views/ShopInventoryCategoryDashboard.vue'),
                                children: [
                                  {
                                    path: ':category',
                                    name: 'shop-updateCategory',
                                    component: () => import('./views/ShopInventoryCategoryUpdate.vue')
                                  }
                                ]
                        }, {
                          path: 'brands',
                          name: 'shop-brands',
                          component: () => import('./views/ShopInventoryBrandDashboard.vue')
                  }
                ]
        },
]